import { UsecasesCrudController, ApiCrudObjectControllerBindings } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Provides UI for viewing and editing usecase.
 * @example
 * ```html
 * <salaxy-usecase-details></salaxy-usecase-details>
 * ```
 */

export class UsecaseDetails extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = new ApiCrudObjectControllerBindings();

  /** Uses the UsecasesCrudController */
  public controller = UsecasesCrudController;

  /** Default template is the view  */
  public defaultTemplate = "salaxy-components/workflow/usecases/UsecaseDetails.html";

}
